 //DesktopNavigation.js

 import NavLinks from "./Components/Navigation/NavLinks";
 import './Components/Navigation/NavBar.css';

 const DesktopNavigation = () =>{
     return(
        
        <nav className="DesktopNavigation">
              <NavLinks />
        </nav>
        
     )
 }

 export default DesktopNavigation;

 // Note that NavBar.css and NavLinks.js are imported here
